import { render, staticRenderFns } from "./make.vue?vue&type=template&id=69d90081&scoped=true&"
import script from "./make.vue?vue&type=script&lang=js&"
export * from "./make.vue?vue&type=script&lang=js&"
import style0 from "./make.vue?vue&type=style&index=0&id=69d90081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d90081",
  null
  
)

export default component.exports